module.exports = __webpack_public_path__ + "static/media/personal.25da511e.jpeg";